import { MenuBuilder } from './MenuBuilder'
import { MobileButtonBuilder } from './MobileButtonBuilder'
import { ResizeObserver } from './ResizeObserver'

(async () => {
	const resizeObserver = new ResizeObserver(1200)

	const menuBuilder = new MenuBuilder(resizeObserver)
	window.menu = await menuBuilder.build('[data-navbar-content]')

	const menuButtonBuilder = new MobileButtonBuilder(window.menu)
	window.menuButton = menuButtonBuilder.build('[data-navbar-button]')
	const table = document.querySelectorAll('.mobile-table-wrapper')
	table.forEach(el => {
		if (el) {
			el.addEventListener('touchstart', e => e.stopPropagation())
		}
	})
	const submenuOpenHandler = (submenu) => {
		if (!window.menu.isMobile) return false
		const submenuNode = submenu.node.querySelector('.submenu')
		const subitemsNode = submenuNode.children[0]

		submenuNode.style.height = `${subitemsNode.scrollHeight * Math.ceil(submenuNode.children.length / 2) +
			(Math.floor(submenuNode.children.length / 2) * 10) + 60}px`
		submenuNode.style.paddingTop = '30px'
		submenuNode.style.paddingBottom = '30px'
	}

	const submenuCloseHandler = (submenu) => {
		if (!window.menu.isMobile) return false

		const submenuNode = submenu.node.querySelector('.submenu')
		submenuNode.style.height = '0px'
		submenuNode.style.paddingTop = '0'
		submenuNode.style.paddingBottom = '0'
	}
	const closeMenuItems = () => {
		if (!window.menu.isMobile) return false
		const menuNode = document.querySelector('.menu')
		menuNode.scrollTo(0, 0)
	}
	const selectImg = () => {
		if (window.menu.isMobile) return false

		const photoContainer = document.querySelector('.item-has-submenu.open .submenu-img')
		const pageButtons = document.querySelectorAll('.item-has-submenu.open .subitem')
		const activePage = document.querySelector('.item-has-submenu.open .subitem.active')

		choosePhoto(activePage, photoContainer, pageButtons[0])

		pageButtons.forEach(button => {
			button.addEventListener('mouseenter', () => insertPhoto(photoContainer, button.dataset.src))
			button.addEventListener('mouseleave', () => choosePhoto(activePage, photoContainer, button))
		})
	}

	const choosePhoto = (activePage, photoContainer, pageButton) => {
		if (activePage) {
			insertPhoto(photoContainer, activePage.dataset.src)
		} else {
			insertPhoto(photoContainer, pageButton.dataset.src)
		}
	}

	const insertPhoto = (photoContainer, src) => {
		photoContainer.classList.toggle('animate')
		photoContainer.src = `${window.location.origin}/${src}`
	}

	window.menu.on('close', closeMenuItems)
	window.menu.submenus.map((submenu) => {
		submenu.on('before:open', submenuOpenHandler)
		submenu.on('before:close', submenuCloseHandler)
		submenu.on('after:open', selectImg)
	})
})()



// WEBPACK FOOTER //
// ./templates/rekinysukcesu/js/extensions/mod_menu/script.js